export const mapHeroSectionData = (response) => {
  const partnerDetail = response?.data?.partner_detail || {};
  const heroSectionData = response?.data?.hero || {};
  const floatingBannerData = response?.data?.floating_banner || {};
  const benefitsData = response?.data?.benefits || {};

  const data = {};
  data.partnerSrc = partnerDetail?.thumbnail;
  data.partnerName = partnerDetail.name;
  data.shyftIcon = "icon-Shyft_Logo";
  data.banner = heroSectionData?.hero_background;
  data.bannerMobile = heroSectionData?.hero_background_mob;
  data.title =
    floatingBannerData?.title || "Book A Yoga Trial for Wellness for ₹49 only";
  data.subtitle =
    floatingBannerData?.subtitle ||
    "Attend a live, interactive session for overall well-being that helps —";
  data.benefits = benefitsData?.benefits || [];

  return data;
};

export const mapHowItWorksSectionData = (response) => {
  const brandRecognitionData = response?.brand_recognition || {};

  const data = { ...response };

  data.video = brandRecognitionData?.video;
  data.title = brandRecognitionData?.why_shyft_text;
  data.subtitle = brandRecognitionData?.why_shyft_heading;
  data.slug = response?.hero?.hero_signup_primary_pricing?.package_slug;
  data.price = response?.hero?.hero_signup_primary_pricing;
  data.yogaDropdownSlugOption = response?.forms?.services[0].slugs;

  return data;
};

export const mapFeaturesSectionData = (response) => {
  const featuresData = response?.data?.features || {};

  const data = {};

  data.features = featuresData?.features;
  data.featuresAndBenefits = {
    features_and_benefits: {
      title: "Features & Benefits",
      components: featuresData?.features,
    },
  };

  return data;
};

export const mapAllPackagesData = (response) => {
  const allPackagesData = response?.data?.all_packages;

  return allPackagesData;
};

export const mapPartnerBannerData = (response) => {
  const partnerDetail = response?.partner_detail || {};
  const data = {};

  data.partnerSrc = partnerDetail?.thumbnail;
  data.logoSize = {
    maxHeight: "82px",
    maxWidth: "233px",
    maxMobileHeight: "64px",
    maxMobileWidth: "207px",
  };
  data.locoSubtext = partnerDetail?.description;
  data.name = partnerDetail?.name;
  data.title = partnerDetail?.title;
  data.subtitle = partnerDetail?.subtitle;
  data.formLogo = partnerDetail?.reserve_image;

  return data;
};

export const mapFloatingCTAData = (response) => {
  const heroSectionData = response?.data?.hero || {};

  const data = {};

  data.buttonText = heroSectionData?.hero_cta_title_constant;
  data.buttonPrice = heroSectionData?.hero_signup_primary_pricing?.price;
  data.packageSlug = heroSectionData?.hero_signup_primary_pricing?.package_slug;

  return data;
};

export const mapInstructorsData = (response) => {
  const instructorsData = response?.data?.our_instructors;

  return instructorsData;
};
